import { client } from "api";
import { Checklist } from "models/Checklist";

export type MoveChecklistRequest = { checklistId: string; newOrderId: string };
export type MoveChecklistResponse = Checklist | null;

export const moveChecklist = (params: MoveChecklistRequest) =>
  client.post<MoveChecklistResponse>(`/checklist/move-checklist`, params).then((res) => res.data);
